import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import FirstChoice from "../components/Form/Race/FirstChoice";
import InserimentoDati from "../components/Form/Race/InserimentoDati";
import SelezioneTeam from "../components/Form/Race/SelezioneTeam";
import CreazioneTeam from "../components/Form/Race/CreazioneTeam";
import SostieniSquadra from "../components/Form/Race/SostieniSquadra";
import SostieniInserimentoDati from "../components/Form/Race/SostieniInserimentoDati";
import RaceItalia from "../components/Form/Race/RaceItalia";
import RegalaIscrizioneBegin from "../components/Form/Race/RegalaIscrizioneBegin";

// import FormPagamento from "../components/Form/Race/FormPagamento";
import TeamCreato from "../components/Form/Race/TeamCreato";

export default new Router({
    routes: [
        {path: '/', component: FirstChoice, name:'first-choice'},
        {path: '/iscrizione/:id', component: InserimentoDati, name: 'inserimento-dati'},
        {path: '/selezione-team', component: SelezioneTeam, name: 'selezione-team'},
        {path: '/creazione-team', component: CreazioneTeam, name: 'creazione-team'},
        {path: '/sostieni-squadra', component: SostieniSquadra, name: 'sostieni-squadra'},
        {path: '/sostieni-inserimento-dati', component: SostieniInserimentoDati, name: 'sostieni-inserimento-dati'},
        {path: '/team-creato', component: TeamCreato, name: 'team-creato'},
        {path: '/race-italia', component: RaceItalia, name: 'race-italia'},
        {path: '/regala-iscrizione', component: RegalaIscrizioneBegin, name: 'regala-iscrizione'},
        // {path: '/finale', component: FormPagamento, name: 'pagamento'},
    ],
    // eslint-disable-next-line
    base:'/race/iscrizione/'+id_race+'/',
    mode: 'history',
})
